import { render, staticRenderFns } from "./ListCISTasks.vue?vue&type=template&id=222836fd&scoped=true&"
import script from "./ListCISTasks.vue?vue&type=script&lang=js&"
export * from "./ListCISTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222836fd",
  null
  
)

export default component.exports